import httpClient from "../http-client";

const ENDPOINT = "/evento/cupon";

export interface CreateCuponEventoDto {
  prefijo: string;
  cantidad: number;
  porcentajeDescuento: number;
  motivo: string;
}

export interface CreateCuponEventoResponseDto {
  lote: string;
  motivo: string;
  cantidad: number;
  porcentajeDescuento: number;
  cupones: GetCuponEvento[];
}

export interface GetCuponEvento {
  id: number;
  cupon: {
    // cupon
    id: number;
    codigo: string;
  };
}

export interface GetCuponMultipleCanjeados {
  id: number;
  cupon: {
    id: number;
    codigo: string;
  }
  canjeadoPor: {
    id: number;
    nombre: string;
    apellido: string;
  }
}

class CuponEventoService {
  getAll(idEvento: string | number): Promise<GetCuponEvento[]> {
    return httpClient.get(`${ENDPOINT}/${idEvento}`).then(response => {
      if (response.data) {
        return response.data;
      }
    });
  }

  /**
   * 
   * @param idEvento 
   * @returns 
   */
  getAllMultiples(idEvento: string | number): Promise<GetCuponEvento[]> {
    return httpClient.get(`${ENDPOINT}/multiples/${idEvento}`).then(response => {
      if (response.data) {
        return response.data;
      }
    });
  }

  crear(
    idEvento: string | number,
    createDto: CreateCuponEventoDto
  ): Promise<CreateCuponEventoResponseDto> {
    return httpClient
      .post(`${ENDPOINT}/${idEvento}`, createDto)
      .then(response => {
        if (response.data) {
          return response.data;
        }
      });
  }

  /**
   * 
   * @param idEvento 
   * @param createDto 
   * @returns 
   */
  crearMultiples(
    idEvento: string | number,
    createDto: CreateCuponEventoDto
  ): Promise<CreateCuponEventoResponseDto> {
    return httpClient
      .post(`${ENDPOINT}/multiples/${idEvento}`, createDto)
      .then(response => {
        if (response.data) {
          return response.data;
        }
      });
  }

  validar(dto: { eventoID?: number; carreraID?: number; codigo: string , tallaID?: number, distanciaID?: number}) {
    return httpClient.post(`${ENDPOINT}/validar`, dto);
  }

  /**
   * 
   * @param idCupon 
   */
  obtenerCanjeadosCuponMultiple(idCupon: number, idEvento: number | string): Promise<GetCuponMultipleCanjeados[]> {
    return httpClient
    .get(`${ENDPOINT}/multiples/${idEvento}/canjeados/${idCupon}`)
    .then(response => {
      if (response.data) {
        return response.data
      }
    });
  }
}
export default new CuponEventoService();
